import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './VisualitzacioContainerMapaObservadors.module.css';
import WrapperPlegable from '../commons/WrapperPlegable';
import VisualitzacioMapaLlegenda from './VisualitzacioMapaLlegenda';
import ErrorBoundaryWrapper from '../commons/ErrorBoundaryWrapper';
import {
  optionOpenStreetMap,
  optionsBaseMeteocat,
} from '../commons/ConfiguracioLayers';
import Mapa from '../commons/VisualitzacioMapa';
import TileLayer from '../commons/TileLayer';
import BaseSMCLayer from '../commons/BaseSMCLayer';
import VectorLayerObservadors from './VectorLayerObservadors';
import { getObservadorsEspecies } from '../../reducers';
import config from '../../configuracioEntorns';

const baseLayers = () => {
  return [
    {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      options: optionOpenStreetMap,
      name: 'OSM',
      isBaseLayer: true,
      defaultActiveLayer: true,
    },
  ];
};

class VisualitzacioContainerMapa extends PureComponent {
  renderBaseLayers(lMap, lControl) {
    const tilesLayers = baseLayers().map(
      ({ url, options, name, isBaseLayer, defaultActiveLayer }) => {
        return (
          <TileLayer
            key={name}
            url={url}
            options={options}
            name={name}
            lMap={lMap}
            lControl={lControl}
            isBaseLayer={isBaseLayer}
            defaultActiveLayer={defaultActiveLayer}
          />
        );
      }
    );

    const SMCBaseLayer = [
      <BaseSMCLayer
        key={'BaseSMC'}
        url={config.mapa.tilesUrl}
        options={optionsBaseMeteocat}
        name="Base SMC"
        lMap={lMap}
        lControl={lControl}
      />,
    ];

    return tilesLayers.concat(SMCBaseLayer);
  }

  visualitzarControls = () => {
    const { observadors } = this.props;
    return Array.isArray(observadors) && observadors.length > 0;
  };

  listenerAfegirNovaCapa(lMap) {
    //crea un nou listener per quan s'afegueix una capa. Això pasa quan es activa i desactiva una capa del control.
    //Es valida que l'event no aixi estat cridat anteriromente orcontrols controls
    if (lMap && !lMap.listens('overlayadd')) {
      lMap.on('overlayadd', ({ layer }) => {});
    }
  }

  listenerEliminarCapa(lMap) {
    //Cuando se deselecciona la capa del control layer se ha quitar la leyenda
    if (lMap && !lMap.listens('overlayremove')) {
      lMap.on('overlayremove', ({ layer }) => {});
    }
  }

  esArrayConDatos(obj) {
    return obj && Array.isArray(obj) && obj.length > 0;
  }

  render() {
    const { observadors } = this.props;
    const observadorDeAlta = observadors.filter(
      (observador) => observador.dataBaixa === null
    );
    return (
      <div className={styles.Mapa}>
        {
          <Mapa>
            {(lMap, lControl) => {
              if (!lMap || !lControl) {
                return;
              }

              this.listenerAfegirNovaCapa(lMap);
              this.listenerEliminarCapa(lMap);

              //Capes base
              //Afegir en un array tantes capes com calgui
              const baseTileLayers = this.renderBaseLayers(lMap, lControl);

              //observadors
              const observadorsLayer = [
                <VectorLayerObservadors
                  key={'Observadors'}
                  dades={observadorDeAlta}
                  lMap={lMap}
                  name="Observadors"
                  active={true}
                />,
              ];

              //Unimos todas las capas en un nuevo array
              let layers = baseTileLayers.concat(observadorsLayer);

              //para no tener que añadir la propiedad key a cada componente
              return React.createElement(React.Fragment, {}, ...layers);
            }}
          </Mapa>
        }

        <div className={styles.MapaLlegendaWrapper}>
          <WrapperPlegable titol="Llegenda">
            <VisualitzacioMapaLlegenda />
          </WrapperPlegable>
        </div>
      </div>
    );
  }
}

VisualitzacioContainerMapa.propTypes = {
  props: PropTypes.object,
  observadors: PropTypes.array,
};

const mapStateToProps = (state) => ({
  observadors: getObservadorsEspecies(state),
});

export default ErrorBoundaryWrapper(
  connect(mapStateToProps)(VisualitzacioContainerMapa)
);
